
import React, { useCallback, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addManageAirportDestinations, getCountryList, getAirportCode, getCityList, getManageDestinationsData, updateManageAirportDestinations } from "../../services/userservice";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { fetchFlightCountryList } from "../../features/common/flightSearchListSlice";
import { useDispatch, useSelector } from "react-redux";

const AddManageAirportDestinations = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();

    const [filteredCountries, setFilteredCountries] = useState([]);


    const [formData, setFormData] = useState({
        country_name: "",
        city_name: "",
        airport_code: "",
        meta_title: "",
        meta_description: "",
        destination_description: "",
        meta_keyword: "",
        status: ""
    });
    const [searchQuery, setSearchQuery] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };


    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            country_name: searchQuery
        }));
    }, [searchQuery]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        for (let key in formData) {
            if (key !== "airport_code" && formData[key] === "") {
                setError(`Please fill in the required field: ${key.replace('_', ' ')}`);
                setLoading(false);
                return;
            }
        }

        try {
            const formDataToSend = {
                ...formData,
                country_name: searchQuery
            };

            console.log("Sending data: ", formDataToSend);
            const response = id && id !== "add"
                ? await updateManageAirportDestinations(id, formDataToSend)
                : await addManageAirportDestinations(formDataToSend);

            console.log("API response: ", response);
            setShowModal(true);
            setTimeout(() => {
                navigate('/manage-airport-destinations-list');
                setShowModal(false);
            }, 2000);
        } catch (error) {
            setError(error.message || "An error occurred while submitting the form.");
        } finally {
            setLoading(false);
        }
    };



    const generateMetaTags = () => {
        const title = `${formData.city_name} - ${formData.airport_code}`;
        const plainTextDescription = formData.destination_description.replace(/<[^>]*>?/gm, "");

        const description = `${formData.city_name}, ${plainTextDescription}`;
        const keywords = `${formData.city_name}, ${formData.airport_code}, ${formData.meta_keyword}`;

        setFormData((prevData) => ({
            ...prevData,
            meta_title: title,
            meta_description: description,
            meta_keyword: keywords,
        }));
    };


    useEffect(() => {
        if (id && id !== "add") {
            fetchManageDestinationsData(id);
        }
    }, [id]);

    const fetchManageDestinationsData = async (id) => {
        try {
            setLoading(true);
            const response = await getManageDestinationsData(id);
            if (response) {
                setFormData({
                    country_name: response.country_name || "",
                    city_name: response.city_name || "",
                    meta_title: response.meta_title || "",
                    meta_description: response.meta_description || "",
                    destination_description: response.destination_description || "",
                    airport_code: response.airport_code || "",
                    meta_keyword: response.meta_keyword || "",
                    status: response.status || "active"
                });
            }
        } catch (error) {
            setError(error.message || "An error occurred while fetching destination data.");
        } finally {
            setLoading(false);
        }
    };

    const [cityData, setCityData] = useState([]);
    const [airportCode, setAirportCode] = useState([]);

    useEffect(() => {
        fetchCountryData();
    }, []);


    const [countryData, setCountryData] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const fetchCountryData = () => {
        setLoading(true);
        getCountryList()
            .then((response) => {
                const countries = Array.isArray(response.data) ? response.data : [];
                setCountryData(countries);
                setFilteredCountries(countries);
            })
            .catch((error) => {
                setError(error.message || "Error fetching country data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchCountryData();
    }, []);

    const handleSearchChange = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = countryData.filter((country) =>
            country.name.toLowerCase().includes(query)
        );
        setFilteredCountries(filtered);
        setShowDropdown(true);
    };

    const [searchCityQuery, setSearchCityQuery] = useState('');

    useEffect(() => {
        if (formData?.city_name) {
            setSearchCityQuery(formData.city_name);
        }
    }, [formData]);

    const [searchTermFrom, setSearchTermFrom] = useState(formData?.city_name);

    const [filteredCities, setFilteredCities] = useState([]);
    const [showCityDropdown, setShowCityDropdown] = useState(false);

    const fetchCityData = (countryCode) => {
        if (!countryCode) return;
        setLoading(true);
        getCityList(countryCode)
            .then((response) => {
                const cities = Array.isArray(response.data) ? response.data : [];
                setCityData(cities);
                setFilteredCities(cities);
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching city data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCityChange = (cityName) => {
        setShowCityDropdown(false);
        setFormData({ ...formData, city_name: cityName });
        setSearchCityQuery(cityName);
        fetchAirportCode(cityName);
    };

    const fetchAirportCode = (cityId) => {
        if (formData.country_name && cityId) {
            setLoading(true);
            getAirportCode(formData.country_name, cityId)
                .then((response) => {
                    setAirportCode(response?.data || []);
                })
                .catch((error) => {
                    setError(error.message || "An error occurred while fetching airport code.");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };


    const handleAirportChange = (event) => {
        const value = event.target.value;
        setFormData((prev) => ({
            ...prev,
            airport_code: value,
        }));
    };

    const { flightList } = useSelector((state) => state.flightList);
    const dispatch = useDispatch();

    const debounce = (func, delay) => {
        let debounceTimer;
        return function (...args) {
            const context = this;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    };

    const fetchCountryList = useCallback(
        debounce((term) => {
            dispatch(fetchFlightCountryList({ searchQuery, searchTerm: term }));
        }, 500),
        [searchQuery, dispatch]
    );

    useEffect(() => {
        if (searchQuery) {
            fetchCountryList(searchTermFrom);
        }
    }, [searchTermFrom, searchQuery, showCityDropdown, fetchCountryList]);

    const handleSearchCityChange = (event) => {
        setSearchCityQuery(event.target.value);
        setSearchTermFrom(event.target.value);
        setShowCityDropdown(true);
    };


    const handleCountryChange = (countryCode, countryName) => {
        setFormData({ ...formData, country_name: countryCode });
        setSearchQuery(countryName);
        setShowDropdown(false);

    };


    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Manage Destination </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Manage Destination</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            {error && <div className="alert alert-danger">{error}</div>}

                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Country Name</label>
                                            <input
                                                type="text"
                                                value={searchQuery || formData?.country_name}
                                                // value={showDropdown || !formData.country_name ? searchQuery : formData.country_name}
                                                onChange={handleSearchChange}
                                                placeholder="Search country"
                                                className="form-control mb-2"
                                                onFocus={() => setShowDropdown(true)}
                                            />

                                            {showDropdown && !loading && filteredCountries.length > 0 && (
                                                <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: '1000', marginTop: "-12px" }}>
                                                    {filteredCountries.map((country) => (
                                                        <button
                                                            key={country.code}
                                                            className="dropdown-item"
                                                            onClick={() => handleCountryChange(country.code, country.name)}
                                                        >
                                                            {country.name}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Loading and No countries found */}
                                            {loading && <div>Loading countries...</div>}
                                            {!loading && filteredCountries.length === 0 && searchQuery && (
                                                <div>No countries found</div>
                                            )}
                                            {error && <p className="text-danger">{error}</p>}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>City Name</label>
                                            <input
                                                type="text"
                                                value={searchCityQuery}
                                                // value={searchCityQuery}
                                                // value={showCityDropdown || !formData.city_name ? searchCityQuery : formData.city_name}
                                                onChange={handleSearchCityChange}
                                                placeholder="Search city"
                                                className="form-control mb-2"
                                                onFocus={() => setShowCityDropdown(true)}
                                                disabled={!formData.country_name || loading}
                                            />
                                            {/* <p>{searchCityQuery}</p> */}
                                            {showCityDropdown && flightList?.data && !loading && flightList?.data.length > 0 && (
                                                <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: '1000', marginTop: "-12px" }}>
                                                    {flightList?.data?.map((city) => (
                                                        <button
                                                            key={city.id}
                                                            className="dropdown-item"
                                                            onClick={() => handleCityChange(city.city)}
                                                        >
                                                            {city.city}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Loading and No cities found */}
                                            {loading && <div>Loading cities...</div>}
                                            {error && <p className="text-danger">{error}</p>}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Airport Code</label>
                                            <select
                                                value={formData?.airport_code}
                                                onChange={handleAirportChange}
                                                name="airport_code"
                                                disabled={!formData.city_name || loading}
                                                className="form-control"
                                            >
                                                <option value="">Select an Airport Code</option>
                                                {airportCode.map((airport) => (
                                                    <option key={airport.code} value={airport.code}>
                                                        {airport.code}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>Destination Description</label>
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={formData.destination_description}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        destination_description: data,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="col-sm-12 mb-4">
                                        <button type="button" onClick={generateMetaTags} className="btn btn-success mt-2">
                                            Generate Meta Tags
                                        </button>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Meta Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="meta_title"
                                                value={formData.meta_title}
                                                onChange={handleInputChange}
                                                placeholder="Enter Meta Title"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Meta Keyword</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="meta_keyword"
                                                value={formData.meta_keyword}
                                                onChange={handleInputChange}
                                                placeholder="Enter Meta Keyword"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Meta Description</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="meta_description"
                                                value={formData.meta_description}
                                                onChange={handleInputChange}
                                                placeholder="Enter Meta Description"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={formData.status}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    {loading ? "Save Destination" : "Save Destination"}
                                </button>
                            </form>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddManageAirportDestinations;